// ─────────────────────────────────────────────────────────────────
// Glass-i — DGU-consumables STOCK API client (Stage DGU-CONSUMABLE-2).
// Over /api/erp/inventory/dgu-consumable-stock/*.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/inventory/dgu-consumable-stock';
function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const dguConsumableStockApi = {
  stock:  (params = {}) => client.get(BASE, { params }).then(unwrap),
  ledger: (params = {}) => client.get(`${BASE}/ledger`, { params }).then(unwrap),
  // Manual opening balance / correction — deltaQty is signed (+add, −reduce).
  adjust: (body = {}) => client.post(`${BASE}/adjust`, body).then(unwrap)
};

export default dguConsumableStockApi;
